import React from 'react'
import { AutocompleteInput, Create, SaveButton, SimpleForm, TextInput, Toolbar, translate } from 'react-admin'
import { containsRestrictedFieldName } from '../models/restrictedNames'
import { AssetTypeScopeInputs } from './AssetTypeScopeInputs'

const SaveOnlyToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton disabled={props.invalid} />
  </Toolbar>
)

const AssetCustomFieldCreate = ({ accessible, dispatch, recordLiveValues, roles, translate, ...props }) => {
  const validateName = (value) =>
    !containsRestrictedFieldName(value) ? undefined : translate('main.restricted_field_name')

  const toolbar = <SaveOnlyToolbar />
  return (
    <Create {...props}>
      <SimpleForm toolbar={toolbar} redirect="list" defaultValue={{ globalField: true }}>
        <TextInput source="name" resettable validate={validateName} />
        <AutocompleteInput
          source="type"
          choices={[
            { id: 'text', name: 'Text' },
            { id: 'date', name: 'Date' },
          ]}
          defaultValue="text"
        />
        <AssetTypeScopeInputs />
      </SimpleForm>
    </Create>
  )
}

export default translate(AssetCustomFieldCreate)
